import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { Tiendas } from "../../Tiendas/Tiendas";

export const ACTEditarTienda: EntityClientAction = {
    name: 'ACTEditarTienda',
    label: 'Editar Tienda',
    title: <Text fw={700}>Editar Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: ['regt_brwTiendasPorRegion'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const tiendas = new Tiendas(entity.API.client);
        tiendas.def.columns.c_tienda_id.value = selectedKeys![0].c_tienda_id as unknown as string || '';

        await openEntityForm({
            modals: modal,
            formProps: {
                entity: tiendas,
                initialFormMode: 'edit',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
            handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
        });

        return false;
    }
}